import { useEffect, useState, useRef } from 'react';
import styles from './ReviewHotpleModal1.module.css';
import DetailHeader from '../DetailHeader/DetailHeader';
import api from '../../../../../api';
import axios from 'axios'
import { openInstagramMedia } from '../../../../../util';


const ReviewHotpleModal1 = ({setHotpleModalPage, editedHotple, updateHotpleField, originalHotple, updateHotpleInfo, account, marginTop, isEditRequest=false}) => {
      const [beforeInfo, setBeforeInfo] = useState(null);
      const [isPatching, setIsPatching] = useState(false);
      const selectRef = useRef(null);

      const sub_category1 = {
            "음식점": [
                "한식", "양식", "아시아음식", "회/해산물", "고기집", "일식", "중식", "분식", "뷔페", "길거리음식", "패스트푸드", "기타"
            ],
            "주점": [
                "일반주점", "맥주/호프", "칵테일바", "와인바", "이자카야", "이색주점"
            ],
            "카페디저트": [
                "커피/음료", "베이커리", "브런치카페", "디저트", "이색카페", "길거리간식", "전통차"
            ],
            "팝업스토어": [
                "뷰티/패션", "푸드", "아티스트", "인플루언서", "캐릭터", "드라마/영화", "애니메이션", "테크/IT", "브랜드", "기타"
            ],
            "오락액티비티": [
                "테마/워터파크", "스포츠", "겨울레저", "수상레저", "VR/AR", "오락실/노래방", "게임/PC", "사격/슈팅", "익스트림", "이색액티비티"
            ],
            "문화예술": [
                "축제/행사", "공연/콘서트", "문화재", "전시", "도서/음악", "체험/클래스", "영화/드라마", "기타"
            ],
            "숙소": [
                "캠핑/글램핑", "펜션/풀빌라", "호텔/리조트", "게스트하우스", "민박/홈", "모텔", "전통숙소"
            ],
            "휴식힐링": [
                "스파/찜질", "농장/동물", "소품샵/쇼핑", "산/숲", "꽃/나무", "바다/해변", "강/호수", "공원/정원", "산책로", "마을", "기타"
            ]
      }

      function isValidCategory(item){
            const [main, sub1, sub2] = item.split('>');
            return sub_category1[main].includes(sub1)
      }

      function getTextWidth(text, font) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            context.font = font;
            return context.measureText(text).width+2;
      }

      const handleNextButtonClick = async () => {
            if(editedHotple.name==''||editedHotple.sub_category1==''||editedHotple.sub_category2=='')
                  return;

            setHotpleModalPage(editedHotple.main_category=='음식점'||editedHotple.main_category=='주점'||editedHotple.main_category=='카페디저트'||editedHotple.main_category=='숙소'?3:2)
      };

      const handleReInferenceInstaButtonClicked = async () => {
            if(isPatching)
                  return;

            const confirm = window.confirm(`인스타 정보를 다시 AI로 분석하시겠습니까?`);
    
            if (confirm) {
                  setIsPatching(true);
                  try {
                        const response = await api.patch(`/admin/hotple/${originalHotple.hotple_id}`);

                        const new_hotple = response.data.hotples[0];
                        new_hotple.old_hotple_id = originalHotple.hotple_id;

                        setHotpleModalPage(0);
                        updateHotpleInfo('changeHotpleAfterInference', new_hotple);
                  } catch (error) {
                        setIsPatching(false);
                  }
            }
      }

      const handleReGetImageButtonClicked = async () => {
            if(isPatching)
                  return;

            const confirm = window.confirm(`이미지를 다시 가져오시겠습니까?`);
    
            if (confirm) {
                  setIsPatching(true);
                  try {
                        const response = await api.patch(`/admin/media/${originalHotple.media_id}/image_patch`);

                        const new_hotple = response.data.hotples[0];
                        new_hotple.old_hotple_id = originalHotple.hotple_id;

                        setHotpleModalPage(0);
                        updateHotpleInfo('changeHotpleAfterInference', new_hotple);
                  } catch (error) {
                        setIsPatching(false);
                  }
            }
      }

      const handleReInferenceNaverButtonClicked = async () => {
            if(isPatching)
                  return;

            const confirm = window.confirm(`네이버 정보를 다시 AI로 분석하시겠습니까?`);
    
            if (confirm) {
                  setIsPatching(true);
                  try {
                        const response = await axios.post(
                              'https://hotple.today/win-api/api/analysis-naver',
                              { hotple_id: originalHotple.hotple_id }
                        );

                        const new_hotple = response.data.hotples[0];
                        new_hotple.old_hotple_id = originalHotple.hotple_id;

                        setHotpleModalPage(0);
                        updateHotpleInfo('changeHotpleAfterInference', new_hotple);
                  } catch (error) {
                        setIsPatching(false);
                  }
            }
      }

      const handleCancelButtonClick = () => {
            updateHotpleField("name", beforeInfo.name);
            updateHotpleField("main_category", beforeInfo.main_category);
            updateHotpleField("sub_category1", beforeInfo.sub_category1);
            updateHotpleField("sub_category2", beforeInfo.sub_category2);
            if(isEditRequest)
                  setHotpleModalPage(21);
            else
                  setHotpleModalPage(11);
      };

      const handleRecommendButtonClick = (item) => {
            const [main, sub1, sub2] = item.split('>');
            updateHotpleField("main_category", main);
            updateHotpleField("sub_category1", sub1);
            updateHotpleField("sub_category2", sub2);
      };

      const handleManualClick = () => {
            updateHotpleField("main_category", '');
            updateHotpleField("sub_category1", '');
            updateHotpleField("sub_category2", '');
      };

      const handleMainCategoryChange = (category) => {
            if (editedHotple.main_category === category) return;
            updateHotpleField("main_category", category);
            updateHotpleField("sub_category1", '');
          };

      const handleEditButtonClick = () => {
            if(editedHotple.name==''||editedHotple.sub_category1==''||editedHotple.sub_category2=='')
                  return;

            if(isEditRequest)
                  setHotpleModalPage(21);
            else
                  setHotpleModalPage(11);
      };

      useEffect(() => {
            const subCategoryInput2 = document.getElementById('subCategoryInput2');
            const initialFont = window.getComputedStyle(subCategoryInput2).font;
            const initialWidth2 = getTextWidth(editedHotple.sub_category2, initialFont);
            const initialOriWidth2 = getTextWidth(originalHotple.sub_category2, initialFont);
            if(editedHotple.sub_category2!='')
                  subCategoryInput2.style.width = initialWidth2 + 'px';
            else
                  subCategoryInput2.style.width = initialOriWidth2 + 'px';
      }, [editedHotple]);

      useEffect(() => {
            if(!originalHotple.need_verify)
                  setBeforeInfo(editedHotple);
      },[]);

      return (
            <div className={styles.reviewmodal1} style={{maxHeight: `calc(100dvh - ${marginTop + 24}px)`, marginTop: `${marginTop}px`}}>
                  <div className={styles.mainframe}>
                        <div className={styles.headerframe}>
                              <div className={styles.title}>
                                    <b className={styles.aiContainer}>
                                          {originalHotple.need_verify ?
                                          <>
                                                <p className={styles.ai}>등록된 정보가 정확한지</p>
                                                <p className={styles.ai}>검토 부탁드려요 🙂</p>
                                          </>
                                          :
                                          <>
                                                <p className={styles.ai}>어떻게 수정할까요?</p>
                                          </>
                                          }
                                    </b>
                              </div>
                              <div className={styles.instagrambutton} onClick={()=>openInstagramMedia(originalHotple.media_url)}>
                                    <div className={styles.label}>게시글 확인하고 오기 →</div>
                              </div>

                              {account.isAdmin &&
                                    <>
                                          <DetailHeader hotple={editedHotple} updateHotpleField={updateHotpleField} updateHotpleInfo={updateHotpleInfo}/>
                                          <div className={styles.nameframe}>
                                                <div className={styles.div0}>URL :</div>
                                                <div className={styles.nameinput}>
                                                      <img className={styles.iconpen} alt="" src="images/pen.svg" />
                                                      <input
                                                            type="text"
                                                            id="urlInput1"
                                                            className={styles.nameInput1}
                                                            value={editedHotple.media_url}
                                                            onChange={(e) => updateHotpleField("media_url",e.target.value)}
                                                            placeholder={originalHotple.media_url}
                                                            autoComplete="off"
                                                            onKeyDown={(e) => {if (e.key === 'Enter') {e.target.blur();}}}
                                                      />
                                                </div>
                                          </div>
                                          <div style={{display:'flex', gap:'8px'}}>
                                                <div className={isPatching ? styles.instagrambuttonDisabled : styles.instagrambutton1} onClick={handleReInferenceInstaButtonClicked}>
                                                      인스타 분석
                                                </div>
                                                <div className={isPatching ? styles.instagrambuttonDisabled : styles.instagrambutton1} onClick={handleReGetImageButtonClicked}>
                                                      이미지 요청
                                                </div>
                                                <div className={isPatching ? styles.instagrambuttonDisabled : styles.instagrambutton1} onClick={handleReInferenceNaverButtonClicked}>
                                                      네이버 분석
                                                </div>
                                          </div>
                                    </>
                              }
                              {originalHotple.media_caption &&
                                    <div className={styles.captionFrame}>
                                          <div className={styles.mediaCaption1}>게시글 본문</div>
                                          <div className={styles.mediaCaption} style={{ whiteSpace: 'pre-line', lineHeight: '1.1' }}>{originalHotple.media_caption.replace(/\n{3,}/g, '\n\n')}</div>
                                    </div>
                              }
                        </div>
                        <div className={styles.contentsframe}>
                              <div className={styles.nameframe}>
                                    <div className={styles.div0}>이름 :</div>
                                    <div className={styles.nameinput}>
                                          <img className={styles.iconpen} alt="" src="images/pen.svg" />
                                          <input
                                                type="text"
                                                id="nameInput1"
                                                className={styles.nameInput1}
                                                value={editedHotple.name}
                                                onChange={(e) => updateHotpleField("name",e.target.value)}
                                                placeholder={originalHotple.name}
                                                autoComplete="off"
                                                onKeyDown={(e) => {if (e.key === 'Enter') {e.target.blur();}}}
                                          />
                                    </div>
                              </div>
                              <div className={styles.categoryframe}>
                                    <div className={styles.div1}>분류 :</div>
                                    <div className={styles.buttonsframe}>
                                          <div className={editedHotple.main_category=="음식점"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("음식점")}>
                                                <img className={styles.iconrestaurant} alt="" src="images/restaurant.svg" />
                                                <div className={styles.label1}>음식점</div>
                                          </div>
                                          <div className={editedHotple.main_category=="주점"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("주점")}>
                                                <img className={styles.iconrestaurant} alt="" src="images/alcohol.svg" />
                                                <div className={styles.label1}>주점</div>
                                          </div>
                                          <div className={editedHotple.main_category=="카페디저트"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("카페디저트")}>
                                                <img className={styles.iconrestaurant} alt="" src="images/cafe.svg" />
                                                <div className={styles.label1}>카페/디저트</div>
                                          </div>
                                          <div className={editedHotple.main_category=="팝업스토어"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("팝업스토어")}>
                                                <img className={styles.iconrestaurant} alt="" src="images/popupStore.svg" />
                                                <div className={styles.label1}>팝업스토어</div>
                                          </div>
                                          <div className={editedHotple.main_category=="오락액티비티"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("오락액티비티")}>
                                                <img className={styles.iconrestaurant} alt="" src="images/activity.svg" />
                                                <div className={styles.label1}>오락/액티비티</div>
                                          </div>
                                          <div className={editedHotple.main_category=="문화예술"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("문화예술")}>
                                                <img className={styles.iconrestaurant} alt="" src="images/smile.svg" />
                                                <div className={styles.label1}>문화/예술</div>
                                          </div>
                                          <div className={editedHotple.main_category=="휴식힐링"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("휴식힐링")}>
                                                <img className={styles.iconrestaurant} alt="" src="images/flower.svg" />
                                                <div className={styles.label1}>휴식/힐링</div>
                                          </div>
                                          <div className={editedHotple.main_category=="숙소"? styles.culturalbutton: styles.restarantbutton} onClick={()=>handleMainCategoryChange("숙소")}>
                                                <img className={styles.iconrestaurant2} alt="" src="images/home_filled.svg" />
                                                <div className={styles.label1}>숙소</div>
                                          </div>
                                    </div>
                              </div>
                              <div className={styles.subcategoryframe}>
                                    <div className={styles.div2}>하위 분류 :</div>
                                    <div className={styles.subcategories}>
                                          <div className={styles.subcategory1} onClick={() => selectRef.current?.focus()}>
                                                <select
                                                      ref={selectRef}
                                                      id="subCategoryInput1"
                                                      className={styles.subCategoryInput1}
                                                      value={editedHotple.sub_category1 || ''}
                                                      onChange={(e) => updateHotpleField("sub_category1", e.target.value)}
                                                      onBlur={(e) => e.target.blur()}
                                                >
                                                      <option value="" hidden>-- 선택 --</option>
                                                      {editedHotple.main_category && sub_category1[editedHotple.main_category].map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                      ))}
                                                </select>
                                                <span className={styles.dropdown}>▼</span>
                                          </div>
                                          <div className={styles.subcategory1}>
                                                <img className={styles.iconpen} alt="" src="images/pen.svg" />
                                                <input
                                                      type="text"
                                                      id="subCategoryInput2"
                                                      className={styles.subCategoryInput1}
                                                      value={editedHotple.sub_category2}
                                                      onChange={(e) => updateHotpleField("sub_category2",e.target.value)}
                                                      placeholder={originalHotple.sub_category2}
                                                      autoComplete="off"
                                                      onKeyDown={(e) => {if (e.key === 'Enter') {e.target.blur();}}}
                                                />
                                          </div>
                                    </div>
                              </div>

                              <div className={styles.recommend}>
                                    <div
                                          className={originalHotple.possible_categories?.includes(`${editedHotple.main_category}>${editedHotple.sub_category1}>${editedHotple.sub_category2}`)?styles.subcategory2:styles.subcategory2Active}
                                          onClick={()=>handleManualClick()}      
                                    >
                                          직접입력
                                    </div>
                                    {originalHotple.possible_categories && originalHotple.possible_categories.filter(item => isValidCategory(item)).slice(0, 3).map((item) => (
                                          <div
                                                className={`${editedHotple.main_category}>${editedHotple.sub_category1}>${editedHotple.sub_category2}`==item?styles.subcategory2Active:styles.subcategory2}
                                                onClick={()=>handleRecommendButtonClick(item)}      
                                          >
                                                {item.replaceAll('>',' ▸ ')}
                                          </div>
                                    ))}
                              </div>
                        </div>
                  </div>
                  {originalHotple.need_verify?
                        <div className={
                              editedHotple.name==''||editedHotple.sub_category1==''||editedHotple.sub_category2==''
                              ? styles.nextButton
                              : styles.nextButtonActive}
                              disabled={editedHotple.name==''||editedHotple.sub_category1==''||editedHotple.sub_category2==''}
                              onClick={handleNextButtonClick}>
                              <div className={styles.text}>{`다음으로 (1/${editedHotple.main_category=='음식점'||editedHotple.main_category=='주점'||editedHotple.main_category=='카페디저트'||editedHotple.main_category=='숙소'?'2':'3'})`}</div>
                        </div>
                  :
                        <div className={styles.editbuttonsframe}>
                              <div className={styles.cancelButton} onClick={()=>handleCancelButtonClick()}>
                                    <div className={styles.cancellabel}>돌아가기</div>
                              </div>
                              <div className={editedHotple.name==''||editedHotple.sub_category1==''||editedHotple.sub_category2==''
                              ?styles.editButtonDisabled
                              :styles.editButton}
                              disabled={editedHotple.name==''||editedHotple.sub_category1==''||editedHotple.sub_category2==''}
                              onClick={()=>handleEditButtonClick()}>
                                    <div className={styles.edittext}>수정하기</div>
                              </div>
                        </div>
                  }
            </div>);
};

export default ReviewHotpleModal1;